import { render, staticRenderFns } from "./comment-modal.vue?vue&type=template&id=19d6daaf&scoped=true"
import script from "./comment-modal.vue?vue&type=script&lang=js"
export * from "./comment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6daaf",
  null
  
)

export default component.exports